import { Box, IconButton, useTheme } from "@mui/material";
import { useContext, useState, useEffect } from "react";
import { ColorModeContext, tokens } from "../../../theme";
import InputBase from "@mui/material/InputBase";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";

import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import SearchIcon from "@mui/icons-material/Search";
import userProfile from "../../../Assets/Images/General/avatar.jpg"
import { Link } from "react-router-dom";
import { AuthConsumer, useAuth } from "../../../context/AuthContext";
import CircularProgress from '@mui/material/CircularProgress';
import { ArrowRightAltOutlined } from "@mui/icons-material"
//
const Topbar = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const colorMode = useContext(ColorModeContext);
    //
    const [showProfile, setShowProfile] = useState(false);
    const [showNotif, setShowNotif] = useState(false);

    const [userData, setUserData] = useState("");

    useEffect(() => {
        const currentUserInfo = JSON.parse(localStorage.getItem("authUser"));
        if (currentUserInfo === null || currentUserInfo === "undefined") {
            return setUserData(() => <CircularProgress />);
        }
        setUserData(currentUserInfo);
        // console.log(userData.displayName, "User Data");
    }, []);

    const { signOutUser } = useAuth();

    return (
        <AuthConsumer>
            {(authData) => {
                // const { currentUser } = authData;
                return <>
                    <Box display="flex" justifyContent="space-between"

                        className="navbar-custom"
                        sx={{
                            "&": { background: `${colors.primary[600]} !important`, position: "fixed", width: "100%", right: "0", left: "0", zIndex: "99" },
                            "& ul li a": { fontSize: "13px", textAlign: "left", color: `${colors.grey[100]} !important`, },
                            "& .dropdown-item": {
                                color: `${colors.grey[200]} !important`,

                            },
                            "& .dropdown-menu svg": { fontSize: "20px !important", marginRight: "10px", color: `${colors.grey[200]} !important` },
                            "& .dropdown-item:focus, & .dropdown-item:hover": {
                                color: `${colors.grey[600]} !important`,
                                backgroundColor: colors.primary[400]
                            },
                            "&  a.dropdown-item:hover svg": {
                                color: `${colors.grey[600]} !important`,
                            },
                            "& .dropdown-menu": {
                                backgroundColor: colors.primary[500]
                            },
                            "& .dropdown-divider": {
                                borderTop: `1px solid ${colors.primary[400]}`
                            },
                            "@media(max-width:769.99px)": {
                                "& .search-box": {
                                    width: "0",
                                    height: "0"
                                },
                                "& .pro-user-name": {
                                    display: "none"
                                },
                                "& .css-1ger9ax": {
                                    marginRight: "5px"
                                }
                            }

                        }
                        }
                    >
                        {/* SEARCH BAR */}
                        <Box
                            className="search-box"
                            display="flex"
                            m={2}
                            height={"2.7rem"}
                            width={"13.5rem"}
                            left="19%"
                            position={"relative"}
                            border={`2px solid ${colors.primary[400]}`}
                            backgroundColor={colors.primary[500]}
                            borderRadius="5rem"

                        >
                            <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search..." type="text" className="center flex" />
                            <IconButton type="button" sx={{ p: 1.5 }} >
                                <SearchIcon />
                            </IconButton>
                        </Box>

                        {/* ICONS */}
                        <Box display="flex" mr={"4rem"}
                            mt={2}
                        >
                            <ul className="flex">
                                <li>
                                    <IconButton onClick={colorMode.toggleColorMode}>
                                        {theme.palette.mode === "dark" ? (
                                            <LightModeOutlinedIcon />
                                        ) : (

                                            <i className="fa fa-moon"></i>
                                        )}
                                    </IconButton>
                                </li>
                                {/* Notification Navbar */}
                                <li className="dropdown notification-list topbar-dropdown">
                                    <IconButton className="nav-link dropdown-toggle"
                                        sx={{
                                            "&": {
                                                marginTop: "-0.5rem",
                                                position: "relative !important"
                                            },

                                        }}
                                        onClick={() => {
                                            if (showProfile) {
                                                setShowNotif(!showNotif);
                                                return setShowProfile(false);
                                            }
                                            return setShowNotif(!showNotif);
                                        }}
                                    >

                                        <i className='fe-bell noti-icon'></i>
                                    </IconButton>
                                    <span className="badge bg-danger rounded-circle noti-icon-badge">9</span>
                                    <div className={showNotif ? "dropdown-menu dropdown-menu-end dropdown-lg d-show" : "dropdown-menu dropdown-menu-end dropdown-lg"} >

                                        {/* <!-- item 1--> */}
                                        {/* <div className="dropdown-item noti-title"> */}
                                        <div className="noti-title text-dark">
                                            <h5 className="m-0 h5">
                                                <span className="float-end">
                                                    <Link to="" className="text-dark">
                                                        <small>Clear All</small>
                                                    </Link>
                                                </span>
                                                Notification
                                            </h5>
                                        </div>

                                        <div className="noti-scroll" data-simplebar>
                                            {/* <!-- item--> */}
                                            <Link to="" className="dropdown-item notify-item active">
                                                <div className="notify-icon">
                                                    <Box display="flex" justifyContent="center" alignItems="center">
                                                        <img
                                                            alt="profile-user"
                                                            width="35px"
                                                            height="35px"
                                                            src={userProfile}
                                                            style={{ cursor: "pointer", borderRadius: "50%", marginRight: "10px" }}
                                                        />
                                                    </Box>
                                                </div>
                                                <p className="notify-details">Cristina Pride</p>
                                                <p className="text-muted mb-0 user-msg">
                                                    <small>Hi, How are you? What about our next meeting</small>
                                                </p>
                                            </Link>

                                            {/* <!-- item--> */}
                                            <Link to="" className="dropdown-item notify-item">
                                                <div className="notify-icon bg-primary rounded-circle bg-secondary">
                                                    <i className="mdi mdi-notfication"></i>
                                                </div>
                                                <p className="notify-details">Caleb Flakelar commented on Admin
                                                    <small className="text-muted">1 min ago</small>
                                                </p>
                                            </Link>

                                            {/* <!-- item--> */}
                                            <Link to="" className="dropdown-item notify-item">
                                                <div className="notify-icon">
                                                    <Box display="flex" justifyContent="center" alignItems="center">
                                                        <img
                                                            alt="profile-user"
                                                            width="35px"
                                                            height="35px"

                                                            src={userProfile}
                                                            style={{ cursor: "pointer", borderRadius: "50%", marginRight: "10px" }}
                                                        />
                                                    </Box>

                                                </div>
                                                <p className="notify-details">Karen Robinson</p>
                                                <p className="text-muted mb-0 user-msg">
                                                    <small>Wow ! this admin looks good and awesome design</small>
                                                </p>
                                            </Link>

                                            {/* <!-- item--> */}
                                            <Link to="" className="dropdown-item notify-item ">
                                                <div className="notify-icon bg-warning">
                                                    <i className="mdi mdi-account-plus"></i>
                                                </div>
                                                <p className="notify-details">New user registered.
                                                    <small className="text-muted">5 hours ago</small>
                                                </p>
                                            </Link>

                                            {/* <!-- item--> */}
                                            <Link to="" className="dropdown-item notify-item ">
                                                <div className="notify-icon bg-info">
                                                    <i className="mdi mdi-comment-account-outline"></i>
                                                </div>
                                                <p className="notify-details">Caleb Flakelar commented on Admin
                                                    <small className="text-muted">4 days ago</small>
                                                </p>
                                            </Link>

                                            {/* <!-- item--> */}
                                            <Link to="" className="dropdown-item notify-item ">
                                                <div className="notify-icon bg-secondary">
                                                    <i className="mdi mdi-heart"></i>
                                                </div>
                                                <p className="notify-details">Carlos Crouch liked
                                                    <b>Admin</b>
                                                    <small className="text-muted">13 days ago</small>
                                                </p>
                                            </Link>
                                        </div>

                                        {/* <!-- All--> */}
                                        <Link to="" className="dropdown-item flex gap-1 center text-primary notify-item notify-all">
                                            View all
                                            <ArrowRightAltOutlined />
                                        </Link>
                                    </div>
                                </li>


                                {/* Nav Profile */}
                                <li>
                                    <Link className="nav-link dropdown-toggle nav-user flex center" to="" role="button" onClick={() => {
                                        if (showNotif) {
                                            setShowProfile(!showProfile)
                                            return setShowNotif(false);
                                        }
                                        return setShowProfile(!showProfile)
                                    }} >
                                        <Box display="flex" justifyContent="center" alignItems="center">
                                            <img
                                                alt="profile-user"
                                                width="35px"
                                                height="35px"

                                                src={userProfile}
                                                style={{ cursor: "pointer", borderRadius: "50%", marginRight: "10px" }}
                                            />
                                        </Box>
                                        <span className="pro-user-name">
                                            {/* TODO:Add User name from db */}
                                            <p> {userData.displayName}</p>
                                            <span><i className="center mdi mdi-chevron-down"></i></span>
                                        </span>
                                    </Link>
                                    <div className={showProfile ? "dropdown-menu dropdown-menu-end profile-dropdown d-show" : "dropdown-menu dropdown-menu-end profile-dropdown"}>
                                        {/* <!-- item--> */}
                                        <div className="dropdown-header">
                                            <h6 className="text-overflow">Welcome!</h6>
                                        </div>

                                        {/* <!-- item--> */}
                                        <Link to="/profile" className="dropdown-item notify-item flex mt-1">
                                            <AccountCircleOutlinedIcon className="d-nav-icons" />
                                            <span>My Account</span>
                                        </Link>

                                        <div className="dropdown-divider"></div>
                                        <Link to="/profile" className="dropdown-item notify-item flex mt-1">

                                            <SettingsOutlinedIcon />

                                            <span>Settings</span>
                                        </Link>
                                        <div className="dropdown-divider"></div>

                                        {/* <!-- item--> */}
                                        <button onClick={() => signOutUser()} className="dropdown-item notify-item flex left float-left">
                                            <span className="d-nav-icons">
                                                <i className="mdi mdi-logout fs-4"></i>
                                            </span>
                                            <span>Logout</span>
                                        </button>
                                    </div>
                                </li>


                            </ul>
                        </Box>
                    </Box >
                </>
            }}
        </AuthConsumer>
    );
};

export default Topbar;
